// @ts-check
import React, { Component } from "react"
import AvailableBroadcast from "../broadcast/AvailableBroadcast"

/**
 * @augments {Component<{children: (props: Broadcastable[]) => any, children: (params: Broadcast_Validation[]) => any}>}
 */
class AvailableValidations extends Component {
    render() {
        return (
            <AvailableBroadcast>
                {broadcast =>
                    this.props.children(broadcast.filter(({ channel }) => channel === "validation"))
                }
            </AvailableBroadcast>
        )
    }
}

export default AvailableValidations



// WEBPACK FOOTER //
// ./src/features/editor/validation/AvailableValidations.js